export default "__VITE_ASSET__29d82e3f__"